import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from '../../store/slices/auth-slice';

function RoleGuard({ allowedRoles }) {
  const loggedInUser = useSelector(selectLoggedInUser);

  return allowedRoles?.includes(loggedInUser.role.name) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  );
}

export default RoleGuard;
